export default {
  slots: {
    root: '!divide-none dark:bg-(--bg-default-dark) dark:ring-(--ring-default-dark)',
    header: '!pt-3 pb-0 pt-5 sm:px-5',
    body: '!py-4 sm:px-5',
    footer: '!pt-0 sm:pb-3 sm:px-5',
  },
}
